import { AnimatePresence, motion } from "motion/react";

import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

import { IconListHeader } from "@/components/icons/main.icons";

import HeaderMenuDisclosure from "../Footer/HeaderMenuDisclosure";

const MobileHeaderList = () => {
  const [opened, setOpened] = useState(false);
  const handleOpening = () => setOpened(!opened);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpened(false);
  }, [pathname]);
  return (
    <div className="">
      <div className="cursor-pointer p-3" onClick={handleOpening}>
        <IconListHeader className="relative z-[100] size-6 stroke-white" />
      </div>
      <AnimatePresence>
        {opened && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="absolute left-0 top-0 z-10 hidden h-screen w-full bg-surface pt-5 max-xl:block"
          >
            <div className="mt-20 px-6 max-md:px-4">
              <HeaderMenuDisclosure />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default MobileHeaderList;
